import { MenuData } from "src/types";

import { NavigationMenuTypes } from "../store";
import { SetNavigationMenu } from "../store/navigationMenu";

export const setNavigationMenuList = (data: MenuData): SetNavigationMenu => ({
  type: NavigationMenuTypes.SET,
  payload: data.menu,
});
